import { useEffect } from "react";
import { useSortable, defaultAnimateLayoutChanges } from "@dnd-kit/sortable";
import { InView } from "react-intersection-observer";
import { CSS } from "@dnd-kit/utilities"

import { useLeadsStatus } from "../../hooks/useLeads.js";
import useGlobalParams from "../../hooks/useGlobalParams.js";
import useStatuses from "../../hooks/useStatuses.js";
import { getStatusId } from "../../utils/kanbanUtils.js";

import StatusColumn from './StatusColumn.js';

const animateLayoutChanges = args => defaultAnimateLayoutChanges({ ...args, wasDragging: true });

export default function DroppableKanbanColumn({ children, columns = 1, disabled, id, items, style, onChangeLeads, leads, nextUrl, onAddLead, onToggleColumn, allowLoadMore, ...props }) {

  const statusId = getStatusId(id);

  const initialData = {
    pages: [{ data: leads, nextUrl: nextUrl || 'None' }],
    pageParams: [],
  };

  const { categoryId } = useGlobalParams();
  const { active, attributes, isDragging, listeners, over, setNodeRef, transition, transform } = useSortable({ id, data: { type: "container", children: items }, animateLayoutChanges });
  const { data: statuses } = useStatuses({ categoryId });
  const { data, hasNextPage, isFetching, isFetchingNextPage, fetchNextPage } = useLeadsStatus({ categoryId, statusId, initialData, staleTime: Infinity, refetchOnWindowFocus: false });

  const dataPages = data?.pages;

  useEffect(() => {
    dataPages && onChangeLeads(dataPages);

    //TODO @HAO fix
    //eslint-disable-next-line
  }, [dataPages]);

  // const isOverContainer = over ? (id === over.id && active?.data.current?.type !== "container") || items.includes(over.id) : false;  
  const isOverContainer = over && ((id === over.id && active?.data.current?.type !== "container") || items.includes(over?.id));

  const onChangeView = inView => {
    inView && allowLoadMore && !isFetching && !isFetchingNextPage && fetchNextPage();
  }

  const containerStyle = {
    ...style,
    transition,
    transform: CSS.Translate.toString(transform),
    opacity: isDragging ? 0.5 : undefined
  };

  const status = statuses?.find(status => status.id === statusId);

  const renderSkeleton = () => (
    <>
      <div className="__kanban-item-skeleton" />
      <div className="__kanban-item-skeleton" />
      <div className="__kanban-item-skeleton" />
    </>
  );

  return (
    <StatusColumn ref={disabled ? undefined : setNodeRef} style={containerStyle} hover={isOverContainer && active?.data.current?.containerId !== id} hoverSelf={isOverContainer && active?.data.current?.containerId === id} handleProps={{ ...attributes, ...listeners }} columns={columns} status={status} onAddLead={onAddLead} {...props} onToggleColumn={onToggleColumn}>
      {children}
      { hasNextPage && (
        // only show interesction observer when more leads can be loaded. allowLoadMode is disabled when a lead in that column is being updated
        (allowLoadMore && !isFetchingNextPage)
        ? <InView onChange={onChangeView}>{ renderSkeleton() }</InView>
        : renderSkeleton()
      )}
    </StatusColumn>
  )
}
